import { API } from "@infra/api";
import { makeBranchMatcherUseCases } from "@app/branchMatcher";
import type { Branch } from "@domain/CRM/branch";
import type { Job } from "@domain/CRM/job";
import type { IBranches } from "@ports/branches/IBranches";
import type { IJobs } from "@ports/jobs/IJobs";
import type { IJobIssues } from "@ports/jobs/IJobIssues";

const jobsApi: Pick<IJobs, "updateField"> = {
	updateField: (id, field, value) => API.Data.Jobs.update.field(id, field, value) as Promise<Job>,
};

const branchesApi: IBranches = {
	getByIds: (ids) => API.Data.Branches.get.byIds(ids) as Promise<Branch[]>,
	updateAgrianOrganizationIds: (id, ids) => API.Data.Branches.update.agrianOrganizationIds(id, ids),
};

const jobIssuesApi: IJobIssues = {
	getAgrian: () => API.Data.Jobs.issues.getAgrian(),
	fixAgrian: (ids) => API.Data.Jobs.issues.fixAgrian(ids),
	getBranchMatcherJobs: () => API.Data.Jobs.issues.getBranchMatcherJobs(),
	getDealMatcherJobs: () => API.Data.Jobs.issues.getDealMatcherJobs(),
	fixDealMatcherJobs: (ids) => API.Data.Jobs.issues.fixDealMatcherJobs(ids),
	fixExeMissionValidationJobs: (ids) => API.Data.Jobs.issues.fixExeMissionValidationJobs(ids),
};

export const branchMatcherUseCases = makeBranchMatcherUseCases({ jobIssuesApi, jobsApi, branchesApi });
